/**
 * ETA Pincode Checker
 * Reuses the existing window.API_CONFIG
 */
(function () {
  "use strict";

  function getETABaseUrl() {
    var crmBaseUrl = window.getAPIUrl("baseUrl");

    if (!crmBaseUrl) {
      throw new Error(
        "API_CONFIG baseUrl not found. Make sure api-config.js loads before eta-pincode-checker.js"
      );
    }

    return crmBaseUrl.replace(/crm\/?$/, "eta");
  }

  function getETAKey() {
    var key = window.getAPIUrl("key");

    if (!key) {
      throw new Error("API_CONFIG key not found.");
    }

    return key;
  }

  /**
   * Calls ETA API for pincode + selected variant SKU.
   */
  async function checkPincodeETA(pincode, productId) {
    var url = getETABaseUrl();
    var key = getETAKey();

    var response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": key
      },
      body: JSON.stringify({
        customerPostalCode: pincode,
        productId: productId
      })
    });

    if (!response.ok) {
      var errorText = "";

      try {
        errorText = await response.text();
      } catch (e) {
        /* ignore */
      }

      throw new Error(
        "ETA API error (" + response.status + "): " + errorText
      );
    }

    return response.json();
  }

  window.KentETA = {
    getETABaseUrl: getETABaseUrl,
    checkPincodeETA: checkPincodeETA
  };
})();